import { FC } from 'react';

import useIsLargeScreen from '~/app/lib/hooks/useIsLargeScreen';
import { ItemPageLayoutProps } from './types';
import DesktopTwoColumnLayout from './DesktopTwoColumnLayout';
import DesktopSingleColumnLayout from './DesktopSingleColumnLayout';
import MobileSingleColumnLayout from './MobileSingleColumnLayout';

const ItemPageLayout: FC<ItemPageLayoutProps> = ({ settings, ...props }) => {
  const isLargeScreen = useIsLargeScreen();

  if (isLargeScreen) {
    switch (settings.desktopLayout) {
      case 'desktopSingleColumn': {
        return (
          <DesktopSingleColumnLayout
            {...props}
            {...settings.desktopSingleColumn}
          />
        );
      }

      case 'desktopTwoColumn': {
        const { content, ...restProps } = props;

        return (
          <DesktopTwoColumnLayout
            primaryContent={content}
            {...restProps}
            {...settings.desktopTwoColumn}
          />
        );
      }
    }
  }

  return (
    <MobileSingleColumnLayout {...props} {...settings.mobileSingleColumn} />
  );
};

export default ItemPageLayout;
